<script lang="ts">
	import {uqn} from './stores.js';
	import check from './check_random/check';
	import Textfield, {Input, Textarea} from '@smui/textfield';
	import Button, {Label, Icon} from '@smui/button';
	import Dialog, {Title, Content, Actions} from '@smui/dialog';
	import Slider from '@smui/slider';
	import FormField from '@smui/form-field';
	import Katex from './Katex.svelte';
	import uqnSplit from './functions/uqnSplit';
	import uqnJoin from './functions/uqnJoin';
	import RadioGroup from './RadioGroup.svelte';
	//import getRandomInt from './functions/getRandomInt';
	//import signAssign from './functions/signAssign';
	//import signUnassign from './functions/signUnassign';

	let simpleDialog;
	
	let aSlide: number;
	let ySymbol: string;
	let _;
	
	// initialize
	let type = $uqn.toString()[0];
	let uqnInput = $uqn;

	// reactive
	$: _ = updateFromType(type);
	$: _ = updateFromUQN($uqn);
	$: _ = updateSlider(type,aSlide);

	let options = [
		{value: "1", label: "\\displaystyle \\frac{z^2}{z^*} \\textrm{ purely imaginary}", katex: true},
		{value: "2", label: "z^3 \\textrm{ purely imaginary}", katex: true},
		{value: "3", label: "\\displaystyle \\frac{z^2}{z^*} \\textrm{ real}", katex: true},
		{value: "4", label: "z^3 \\textrm{ real}", katex: true},
	]

	function updateFromType(t:string){
		if (t!=$uqn.toString()[0]){
			let [_,a,sign] = uqnSplit($uqn);
			uqnInput = uqnJoin([t,a,sign]);
			uqn.set(uqnInput);
		}
	}
	
	function updateFromUQN(u:number){
		uqnInput = u;
		type = u.toString()[0];
		if (type=="2" || type=="1"){
			ySymbol = "b=";
		} else{
			ySymbol = "a=";
		}
		let [_,a,s] = uqnSplit(u);
		if (s==1){
			a *= -1;
		}
		aSlide = a;
	}

	function updateSlider(t:string,a1:number){
		let [_,oldA,oldS] = uqnSplit($uqn);
		if (oldS==1){
			oldA *= -1;
		}
		if (a1 != oldA){
			if (a1==0){
				if (oldA > 0){
					a1 = -1;
				} else{
					a1 = 1;
				}
			}
			aSlide = a1;
			let newS = 0;
			if (a1 < 0){
				newS = 1;
			}
			uqnInput = uqnJoin([t,Math.abs(a1),newS]);
			uqn.set(uqnInput);
		}
	}

	function uqnClick(){
		if (check(uqnInput)){
			uqn.set(uqnInput)
		} else{
			simpleDialog.open();
		}
	}	

</script>

<h2>Options</h2>
<hr>
<h3>UQN</h3>
<p>
	Retrieve a question by keying in a 3 digit UQN :
</p>
<Textfield class="shaped-outlined" variant="outlined" bind:value={uqnInput} label="UQN" type="number"/>
<Button on:click={uqnClick} variant="unelevated" class="button-shaped-round">
	<Label>Generate question</Label>
</Button>
<hr>
<h3>
	Question construction tools
</h3>
<p>First choose the general form of the question:</p>
<RadioGroup bind:radio={type} options={options}/>
<hr>
<p>
	This question is generated by choosing the value of
	{#if type=="1" || type=="2"}
		<Katex math={"b"}/>, where <Katex math="z=a+bi"/>.
	{:else}
		<Katex math={"a"}/>, where <Katex math="z=a+bi"/>.
	{/if}
</p>
<p>
	Use the sliders belows to choose different options to craft your own unique question.
</p>

<div>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={aSlide} min={-9} max={9} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={ySymbol+aSlide.toString()}/></span>
	</FormField>
</div>


<Dialog bind:this={simpleDialog}>
	<!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
	<Title>Invalid UQN</Title>
	<Content>
		You have keyed an invalid UQN. Please try again.
	</Content>
	<Actions>
		<Button>
			<Label>OK</Label>
		</Button>
	</Actions>
</Dialog>
<hr>